import { CHECKOUTFORM_FIELDS } from './checkout-form-fields'

export enum CHECKOUTFORM_VALIDATION_EXCLUDE_FIELD_TYPES {
    FIRSTNAME = 'FirstName',
    LASTNAME = 'LastName',
    EMAIL = 'Email',
    PASSWORD = 'Password',
    COUNTRYCODE = 'CountryCode',
    STATECODE = 'StateCode',
}

export enum CHECKOUTFORM_VALIDATION_HARD_EXCLUDE_FIELD_TYPES {
    IS_DISCLAIMER_AGREED = CHECKOUTFORM_FIELDS.IS_DISCLAIMER_AGREED,
}
